/* eslint-disable prettier/prettier */
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { User } from 'src/app/model/auth/user';
import { SearchResult } from 'src/app/model/search/search-result';
import { entraAuthService } from 'src/app/service/auth.service';
import { ConfigService } from 'src/app/service/config.service';
import { PageContentSearchService } from 'src/app/service/page-content-search.service';
import { PageLoaderService } from 'src/app/service/page-loader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { SessionTimeoutService } from 'src/app/service/session-timeout.service';

import { OrderDetailsService } from '../../screen/order-details-screen/order-detail-service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewChecked {
  @Input() disableHeader: boolean = false;
  public showLogo: boolean = false;
  searchResults: SearchResult[] = [];
  user: User = {} as User;
  disableMenu = false;

  filteredOptions: string[] | undefined;

  private configSubscription: any;
  private routerSubscription: any;
  private breakpointSubscription: any;
  private msalRedirectHandled = false;

  constructor(
    public configService: ConfigService,
    private router: Router,
    private pageLoaderService: PageLoaderService,
    private sandboxPageStateService: SandboxPageStateService,
    public breakpointObserver: BreakpointObserver,
    private pageContentSearchService: PageContentSearchService,
    private orderDetailsService: OrderDetailsService,
    private entraAuthService: entraAuthService,
    private msalService: MsalService,
    private sessionTimeoutService: SessionTimeoutService
  ) {
    this.user = {
      preferredUserName: '',
      userEmail: '',
      isAdminUser: false,
      isSMEUser: false,
      userId: '',
      isNDCAPINewSandboxUser: true
    };

    this.routerSubscription = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this.filteredOptions = this.pageContentSearchService.getSearchResultTitle();
    });
  }

  ngOnInit() {
    this.configSubscription = this.configService.getIsEntraEnabled().subscribe(value => {
      if (!this.msalRedirectHandled) {
        this.msalRedirectHandled = true;
        this.handleMsalRedirect();
      }
    });
 
    this.breakpointSubscription = this.breakpointObserver.observe(['(min-width: 992px)']).subscribe((state: BreakpointState) => {
      this.showLogo = state.matches;
    });
  }

  private handleMsalRedirect() {    
      this.msalService.instance.handleRedirectPromise().then(async () => {
      if (this.entraAuthService.isLoggedIn()) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          
          try {
            const accessToken = await this.entraAuthService.getAccessToken();
            if (accessToken) {
              await this.entraAuthService.setAccessToken();
              this.entraAuthService.setGraphAccessToken();
              this.sessionTimeoutService.startTimeout();
              this.user = this.entraAuthService.getSignedInUser();
              this.sandboxPageStateService.updateUser(this.user);
              const redirectUrl = localStorage.getItem('redirect_url');
              if (redirectUrl) {
                localStorage.removeItem('redirect_url');
                this.router.navigate([redirectUrl]);
              }
              } else {
              console.log('Failed to acquire access token');
            }
          } catch (error) {
            console.log('Error acquiring token:', error);
          }
        }
      }
    });
  }

  ngAfterViewChecked(): void {
    this.disableMenu = window.location.pathname === '/account/register';
  }

  search() {
    this.router.navigate(['/search']);
  }

  startPageLoader() {
    this.pageLoaderService.addPageLoader(true);
  }

  proceedWithLogin() {
    this.startPageLoader();
    localStorage.setItem('redirect_url', '/profile');
    this.msalService.loginRedirect({
      scopes: ['openid', 'profile', 'email', 'User.Read']
    });
  }

  signOutUser() {
    this.sessionTimeoutService.stopTimeout();
    this.entraAuthService.signOutUser();
    this.router.navigate(['/home']);
  }

  get userName() {
    const existingUser = this.sandboxPageStateService.getUser();
    
    if (existingUser.preferredUserName) {
      this.user = existingUser;
    } else {
      this.user = this.entraAuthService.getSignedInUser();
      this.sandboxPageStateService.updateUser(this.user);
    }
    return this.user.preferredUserName || '';
  }

  ngOnDestroy() {
    if (this.configSubscription) {
      this.configSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }
}
